// extracted by mini-css-extract-plugin
export default {"root":"login_root__WUcJ7","logo":"login_logo__7hIJ9"};